// ABOUTME: Layout route for /site-settings/* pages.
// ABOUTME: Restricts site settings to admin and superadmin users.

import { supabase } from "@/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { jwtDecode } from "jwt-decode";

interface JWTPayload {
  user_role?: string;
}

export const Route = createFileRoute("/_authenticated/site-settings")({
  component: SiteSettingsLayout,
});

function SiteSettingsLayout() {
  const { data: hasAccess = false, isLoading } = useQuery({
    queryKey: ["site-settings-admin-check"],
    queryFn: async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session?.access_token) {
        return false;
      }

      const decoded = jwtDecode<JWTPayload>(session.access_token);
      return (
        decoded.user_role === "admin" || decoded.user_role === "superadmin"
      );
    },
    staleTime: Number.POSITIVE_INFINITY,
  });

  if (isLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center text-sm text-muted-foreground">
        Loading site settings...
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center px-6 text-sm text-muted-foreground">
        You do not have permission to view site settings.
      </div>
    );
  }

  return <Outlet />;
}
